import { CommandRequest } from "../../../libs/auth/utilities/command-request";
import { appApi } from "../../../store/app.api";
import { appEndpoint } from "../../../store/app.endpoint";

const TestimonialApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    // Fetch all brands
    getTestimonials: build.query<any, void>({
      query: () => ({
        url: appEndpoint.testimonials,
        method: "get",
      }),
      providesTags: ["Testimonials"], // Tag for cache management
    }),

    // Create a new brand
    createTestimonial: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.testimonials,
        method: "post",
        data: data?.body,
      }),
      invalidatesTags: (result) => (result ? ["Testimonials"] : []),
    }),

    // Update existing brand
    updateTestimonial: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.testimonials}/${data?.id}?_method=put`,
        method: "post",
        data: data?.body,
      }),

    invalidatesTags: (result, error, { body }) => 
        result ? [{ type: 'Testimonials', id: body?.id }, "Testimonials"] : [],
    }),

    // Delete a brand
    deleteTestimonial: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.testimonials}/${data?.id}`,
        method: "delete",
      }),

      invalidatesTags: (result, error, { body }) => 
        result ? [{ type: 'Testimonials', id: body?.id }, "Testimonials"] : [],
    }),
  }),
  overrideExisting: false,
});

// Export hooks for querying and mutating
export const {
  useGetTestimonialsQuery,
  useCreateTestimonialMutation,
  useUpdateTestimonialMutation,
  useDeleteTestimonialMutation,
} = TestimonialApi;